import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { registerOfflineWorker } from './lib/offline';
import { captureAttribution } from './lib/attribution';
import { logAdVisit } from './lib/adVisit';
import { useLang } from './lib/lang';
import './index.css';

// The dashboard's Brand page shows the portal in an iframe at /preview: its own
// small app (no router of the real portal, no session, no API).
const PreviewApp = lazy(() => import('./preview/PreviewApp'));
const isPreview = window.location.pathname === '/preview';

// A page load without a connection shows the offline page, not the browser's error
// (not for the inert preview frame).
if (!isPreview) registerOfflineWorker();
// An ad's UTM tags and fbclid, kept for the visit (first touch) and sent with a new lead.
if (!isPreview) captureAttribution();
// Every landing on /o/<handle> (and its tour page) with the link's raw parameters, for the office.
if (!isPreview) logAdVisit();

const app = isPreview ? (
  <Suspense fallback={null}>
    <PreviewApp />
  </Suspense>
) : (
  <App />
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Google sign-in is offered only when a client ID is configured at build time. */}
    {import.meta.env.VITE_GOOGLE_CLIENT_ID ? (
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID} locale={useLang.getState().lang}>
        {app}
      </GoogleOAuthProvider>
    ) : (
      app
    )}
  </React.StrictMode>,
);
